/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
				}

				this.classList.add('product-recommendations--loaded');
				this.setupEvents();

				setTimeout(() => {
					window.dispatchEvent(new Event('resize'));

					ScrollTrigger.batch('.animations-true .product-card .product-featured-image-link', {
						start: "top 90%",
						onEnter: (elements, triggers) => {
							gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
						}
					});
				});
			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
	setupEvents() {
		this.slideshow = Flickity.data(this.querySelector('slide-show'));
		this.prev = this.querySelector('.flickity-prev');
		this.next = this.querySelector('.flickity-next');

		if (this.next) {
			this.prev.addEventListener('click', () => this.navClick('prev'));
			this.next.addEventListener('click', () => this.navClick('next'));
		}
	}
	navClick(direction) {
		if (direction == 'prev') {
			this.slideshow.previous();
		} else {
			this.slideshow.next();
		}
	}

}

customElements.define('product-recommendations', ProductRecommendations);


document.addEventListener('DOMContentLoaded', () => {

    const parentElement = document.querySelector('body');

    if (parentElement) {
        parentElement.addEventListener('click', (event) => {
            const target = event.target;

            // Check if the clicked element is an add-to-cart button
            if (target.classList.contains('sdev_add_to_cart')) {
                event.preventDefault();

                // Find the hidden input value within the same product container
                const productContainer = target.closest('.product-cart-item-info');
                const hiddenInput = productContainer.querySelector('input[name="id"]');
                
                if (hiddenInput) {
                    const variantId = hiddenInput.value;
                    const qty = 1; // Default quantity
                    const fetchDiscountValue = 'SomeDiscountValue'; // Update with your logic
                    const recommendationProductId = 'SomeRecommendationID'; // Update with your logic

                    // Prepare the data object for the AJAX request
                    const data = {
                        "id": variantId,
                        "quantity": qty,
                        properties: {
                            _discount_price: fetchDiscountValue,
                            _prd_id_main: `${recommendationProductId}`,
                        }
                    };

                    // AJAX request to add product to cart
                    jQuery.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: data,
                        dataType: 'json',
                        success: function () {
                            updateCartDrawer();
                        },
                        error: function (xhr, status, error) {
                            console.error('Error adding item to cart:', error);
                        }
                    });
                }
            }
        });
    }

    function updateCartDrawer() {
        fetch('/cart?section_id=mini-cart')
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const cartDrawer = doc.getElementById('sidebar-cart');
                if (cartDrawer) {
                    document.getElementById('sidebar-cart').innerHTML = cartDrawer.innerHTML;
                    const currentCartDrawer = document.getElementById('sidebar-cart');
                    currentCartDrawer.classList.add('is-open', 'active');
                } else {
                    console.error('Cart drawer not found in the response');
                }
            })
            .catch(error => console.error('Error updating cart drawer:', error));
    }

});
